import css from 'styled-jsx/css'

import { sizes } from '../../theme'
import colors from '../../theme/colors'
import common from '../../theme/common'


export default css`
  .container {
    width: 100%;
    position: relative;
  }

  @media screen and (max-width: ${sizes.media.tablet.maxWidth}) {
    .container {
      display: inline-block;
      border: 1px solid transparent;
    }
  }

  .container :global(.case) {
    position: absolute;
    bottom: 2rem;
    left: 0;
    right: 0;
  }

  .container :global(.case img) {
    width: 100%;
    height: 100%;
  }

  .container :global(.photo) {

  }

  .container :global(.photo img) {
    height: 100%;
    width: 100%;
  }

  .container :global(.name) {
    width: 100%;
    margin-top: 1.2rem;
  }

  .container :global(.background) {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 8rem;
    width: 100%;
  }

  .container.pink :global(.background) {
    background-color: ${colors.softPink};
  }

  .container.pink :global(.name) {
    color: ${colors.pureWhite};
  }

  .container.blue :global(.background) {
    background-color: ${colors.bluishWhite};
  }

  .container.yellow :global(.background) {
    background-color: ${colors.yellow};
  }

  .container.purple :global(.background) {
    background-color: ${colors.governorBayBlue};
  }

  .container.purple :global(.name) {
    color: ${colors.pureWhite};
  }

  .container :global(p.personName) {

    font-family: 'Open Sans Regular', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 25px;
  }

  .container :global(p.title) {

    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    font-family: 'Open Sans Regular', sans-serif;
    text-transform: uppercase;
    margin-top: 0.6rem;
  }
`
